<div class="screen-container">
  <app-card [title]="'basicInfo.title' | translate">
    <div left-content>
      <form [formGroup]="basicInfoForm">
        <div class="content-container">
          <div class="slider-container">
            <app-slider
              [header]="'basicInfo.amountTitle'"
              [control]="amount"
              [error]="getErrors('amount')"
            ></app-slider>
          </div>
          <div class="slider-container">
            <app-slider
              [header]="'basicInfo.durationTitle'"
              [control]="duration"
              [type]="sliderTypes.date"
            ></app-slider>
          </div>

          <div class="input-container">
            <app-input
              [label]="'basicInfo.email'"
              [control]="email"
              [error]="getErrors('email')"
              [inputMode]="'email'"
              [icon]="'email'"
            ></app-input>
          </div>

          <div class="input-container">
            <app-input
              [label]="'basicInfo.phoneNumber'"
              [control]="phoneNumber"
              [error]="getErrors('phoneNumber')"
              [inputMode]="'tel'"
              [type]="'text'"
              [icon]="'phone'"
            ></app-input>
          </div>

          <div class="input-container">
            <app-search
              [label]="'basicInfo.companyNameOrId'"
              [control]="companyName"
              [options]="companies"
              [error]="getErrors('companyName')"
              [loading]="loading"
              (searchSelected)="handleSearchSelected($event)"
            >
            </app-search>
          </div>

          <div class="input-container">
            <app-dropdown
              [label]="'basicInfo.reason'"
              [control]="reason"
              [options]="reasonOptions"
              [optionsTranslationKey]="'reasonOptions'"
              [error]="getErrors('reason')"
            ></app-dropdown>
          </div>

          <div class="button-container">
            <app-deeplink-button
              (buttonClicked)="handleButtonClick()"
              mat-flat-button
              color="primary"
              [text]="'basicInfo.buttonText' | translate"
              [fullWidth]="true"
              [icon]="'none'"
              [loading]="confirmationLoading"
            >
            </app-deeplink-button>
          </div>

          <div class="note">
            {{ "basicInfo.buttonNoteFirstPart" | translate }}
            <a [href]="tosLink" class="link" target="_blank">
              {{ "basicInfo.terms" | translate }}</a
            >
            {{ "basicInfo.buttonNoteSecondPart" | translate }}
          </div>
          <div class="mat-error error" *ngIf="error">
            {{ error }}
          </div>
        </div>
      </form>
    </div>
    <div right-content>
      <app-contact></app-contact>
    </div>
  </app-card>
</div>
